import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableOnlyGiftcardPurchases',
  initialState: false,
  reducers: {
    setEnableOnlyGiftcardPurchases(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableOnlyGiftcardPurchases } = slice.actions;

export default slice.reducer;
